module.exports = __webpack_public_path__ + "static/media/radio-inside.fd3e006c.svg";